// This file was automatically generated and should not be edited.;
import type { SVGProps } from 'react';
import { Ref, forwardRef } from 'react';
const SvgClipboardCheck = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    ref={ref}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6 4.75c-.69 0-1.25.56-1.25 1.25v14c0 .69.56 1.25 1.25 1.25h6a.75.75 0 0 1 0 1.5H6A2.75 2.75 0 0 1 3.25 20V6A2.75 2.75 0 0 1 6 3.25h2.5a.75.75 0 0 1 0 1.5zM14.75 4a.75.75 0 0 1 .75-.75H18A2.75 2.75 0 0 1 20.75 6v9a.75.75 0 0 1-1.5 0V6c0-.69-.56-1.25-1.25-1.25h-2.5a.75.75 0 0 1-.75-.75"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.319 2.417c-.32.377-.466.855-.529 1.215-.086.5-.475.982-1.04 1.094V6.25h6.5V4.726c-.565-.112-.954-.594-1.04-1.094-.063-.36-.21-.838-.529-1.215-.293-.346-.781-.667-1.681-.667s-1.388.321-1.681.667m-1.145-.97C9.762.755 10.674.25 12 .25s2.238.505 2.826 1.197c.52.614.742 1.322.84 1.814A1.25 1.25 0 0 1 16.75 4.5v1.9a1.35 1.35 0 0 1-1.35 1.35H8.6A1.35 1.35 0 0 1 7.25 6.4V4.5a1.25 1.25 0 0 1 1.084-1.24c.098-.491.32-1.2.84-1.813M14.97 19.97a.75.75 0 0 1 1.06 0l1.47 1.47 4.47-4.47a.75.75 0 1 1 1.06 1.06l-5 5a.75.75 0 0 1-1.06 0l-2-2a.75.75 0 0 1 0-1.06"
      clipRule="evenodd"
    />
  </svg>
);
export const ClipboardCheckIcon = forwardRef(SvgClipboardCheck);
